import React from 'react';
import InvestmentDetailsTable from '../InvestmentDetailsTable';
import InvestmentsList from '../InvestmentsList';
import TabTip from '../ui/TabTip';

const DashboardInvestmentsTab = ({ investments, investmentView, setInvestmentView, handleEditInvestment, handleDeleteInvestment, isReadOnly, handleReadOnlyAction, loadDashboardData }) => (
  <>
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div>
        <h2 className="text-lg sm:text-2xl font-serif font-bold text-slate-900">Investment Details</h2>
        <p className="body-text mt-1">Search, filter, and view all your investments</p>
      </div>
      <div className="flex items-center gap-2 bg-slate-100 p-1 rounded-lg">
        <button onClick={() => setInvestmentView('table')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center ${investmentView === 'table' ? 'bg-white text-emerald-600 shadow-xs' : 'text-slate-600 hover:text-slate-900'}`}>Table View<TabTip tip="table_view" showIcon={true} /></button>
        <button onClick={() => setInvestmentView('grouped')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center ${investmentView === 'grouped' ? 'bg-white text-emerald-600 shadow-xs' : 'text-slate-600 hover:text-slate-900'}`}>Grouped View<TabTip tip="grouped_view" showIcon={true} /></button>
      </div>
    </div>
    {investmentView === 'table' ? (
      <InvestmentDetailsTable investments={investments} onEdit={handleEditInvestment} onDelete={handleDeleteInvestment} isReadOnly={isReadOnly} />
    ) : (
      <InvestmentsList investments={investments} onEdit={handleEditInvestment} onRefresh={() => loadDashboardData()} groupByEntity={true} isReadOnly={isReadOnly} onReadOnlyAction={handleReadOnlyAction} />
    )}
  </>
);

export default DashboardInvestmentsTab;
